export {default} from '../../../core/components/DataManagement/DataManagementDetailLocales';
